"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateInsurerParticipantDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
class CreateInsurerParticipantDto {
    constructor(insurerId, sharePercentage, brokeragePercentage, brokerageAmount) {
        this.insurerId = insurerId;
        this.sharePercentage = sharePercentage;
        this.brokeragePercentage = brokeragePercentage;
        this.brokerageAmount = brokerageAmount;
    }
}
exports.CreateInsurerParticipantDto = CreateInsurerParticipantDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 163, description: "Insurer ID" }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerParticipantDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 60.0, description: "Share percentage of insurer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Share percentage is required" }),
    (0, class_validator_1.IsNumber)({ allowInfinity: false, allowNaN: false }, { message: "Share percentage must be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerParticipantDto.prototype, "sharePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 5.0, description: "Brokerage percentage" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Brokerage percentage is required" }),
    (0, class_validator_1.IsNumber)({ allowInfinity: false, allowNaN: false }, { message: "Brokerage percentage must be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerParticipantDto.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1000.0, description: "Brokerage amount" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Brokerage amount is required" }),
    (0, class_validator_1.IsNumber)({ allowInfinity: false, allowNaN: false }, { message: "Brokerage amount must be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerParticipantDto.prototype, "brokerageAmount", void 0);
